const Index = () => import("@/modules/BackOffice/index.vue");

// const Edit = () => import("@/modules/Reports/components/Edit.vue");
const Login = () => import("@/modules/BackOffice/Login.vue");
const Logout = () => import("@/modules/BackOffice/Logout.vue");
const Hardware = () => import("@/modules/BackOffice/Hardware.vue");
const Location = () => import("@/modules/Location/Location.vue");
const Create = () => import("@/modules/Location/components/Create.vue");
const NoSubscription = () => import("@/modules/BackOffice/NoSubscription.vue");
const SelectOrganization = () => import("@/modules/BackOffice/SelectOrganization.vue");
const ForgotPassword = () => import("@/modules/BackOffice/ForgotPassword.vue");
const ResetPassword = () => import("@/modules/BackOffice/ResetPassword.vue");

import NewOrganization from '@/modules/BackOffice/NewOrganization.vue';
import Home from '@/modules/BackOffice/Home.vue';



export default {
  path: '/backoffice',
  component: Index,
  title: 'Back Office',
  // redirect: {
  //   name: 'home'
  // },
  children: [{
      name: 'home',
      path: '/',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}backofficeToken`) == null) {
          console.log('No location code was found', to); // eslint-disable-line
          let url = '/backoffice/login';
          if (to.query && to.query.code) url = `${url}/?`;
          next({
            path: url,
            params: { nextUrl: to.fullPath },
            query: { ...to.params },
          });
        } else {
          console.log('just next?')
          next();
        }
      },
    },
    {
      path: 'login',
      name: 'backOfficeLogin',
      component: Login,
    },
    {
      path: 'forgotPassword',
      name: 'backOfficeForgotPassword',
      component: ForgotPassword,
    },
    {
      path: 'resetPassword',
      name: 'backOfficeResetPassword',
      component: ResetPassword,
    },
    {
      path: 'organization',
      name: 'authentication-select-organization',
      component: SelectOrganization,
    },
    {
      path: 'logout',
      name: 'backOfficeLogout',
      component: Logout,
    },
    {
      path: ':id/location',
      name: 'location-profile',
      component: Location,
    },
    {
      path: 'location/create',
      name: 'location-create',
      component: Create,
    },
    {
      path: 'no-subscription',
      name: 'no-subscription',
      component: NoSubscription,
    },
    {
      path: ':id/hardware',
      name: 'hardware-order',
      component: Hardware,
    },
    {
      path: 'newOrganization',
      name: 'newOrganization',
      component: NewOrganization,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}backofficeToken`) == null) {
          console.log('No location code was found', to); // eslint-disable-line
          let url = '/backoffice/login';
          if (to.query && to.query.code) url = `${url}/?`;
          next({
            path: url,
            params: { nextUrl: to.fullPath },
            query: { ...to.params },
          });
        } else {
          console.log('just next?')
          next();
        }
      },
    },
  ],
  // beforeEnter: ((to, from, next) => {
  //   if (!localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}BackofficeToken`)) {
  //     console.log('here', to, from)
  //     // if (from.name !== "backOfficeLogin") {

  //     // }
  //     next({
  //       path: '/backoffice/login'
  //     })
  //   } else {
  //     console.log('in next')
  //     next() // make sure to always call next()!
  //   }
  // })
};